import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ClassInfoProps {
  courseName: string;
  instructorName: string;
  topic: string;
  duration: string;
  attendees: number;
}

const ClassInfo = ({ courseName, instructorName, topic, duration, attendees }: ClassInfoProps) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h1 className="text-2xl font-headline font-bold text-foreground mb-2">{courseName}</h1>
          <p className="text-lg text-primary font-medium mb-3">{topic}</p>
          <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="UserIcon" size={16} variant="outline" />
              <span>Instructor: <span className="text-foreground font-medium">{instructorName}</span></span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={16} variant="outline" />
              <span>Duration: <span className="text-foreground font-medium">{duration}</span></span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="UsersIcon" size={16} variant="outline" />
              <span><span className="text-foreground font-medium">{attendees}</span> attendees</span>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="px-3 py-1 bg-success bg-opacity-10 text-success rounded-full flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm font-semibold">Live Now</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassInfo;